<template>
  <v-dialog max-width="500px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark dense>
        <v-toolbar-title class="headline">{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex', -1)"
          >close</v-icon
        >
      </v-toolbar>

      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- <v-layout row wrap>
                <v-flex xs12 md6> -->
          <v-text-field label="Extra time name TH" hide-details></v-text-field>
          <v-text-field label="Extra time name EN" hide-details></v-text-field>
          <v-text-field label="Extra time name CN" hide-details></v-text-field>
          <v-layout row justify-start>
            <v-flex
              class="text-xs-left"
              style="margin-top:20px;text-align:center;font-size:16px;color:grey;"
            >
              <!-- <v-checkbox :label="item.days" v-model="checkbox" :value="item.value" color="green"></v-checkbox> -->
              <span>Set extra time</span>
            </v-flex>
            <v-flex xs4 class="text-xs-center">
              <vue-timepicker
                v-model="start_time"
                format="HH:mm"
                :minute-interval="15"
                class="pt-3 underline"
              ></vue-timepicker>
            </v-flex>
            <v-flex xs1 style="margin-top:20px;text-align:center;color:grey;">
              <span>to</span>
            </v-flex>
            <v-flex xs4 class="text-xs-center">
              <vue-timepicker
                v-if="dialog == true"
                v-model="end_time"
                :format="'HH:mm'"
                :minute-interval="15"
                class="pt-3 underline"
              ></vue-timepicker>
            </v-flex>
            <!-- <v-flex xs1>
                        <v-icon large class="mt-3" color="green" >add_box</v-icon>
                        </v-flex> -->
          </v-layout>
          <!-- <v-layout row wrap class="mt-2">
                        <v-flex xs6 style="position:relative;">
                        <label
                            style="font-size:17px;position:absolute;top:15px;color:#616A6B;"
                        >Upload Add-on Image :</label>
                        </v-flex>
                        <v-flex class="ml-2">
                        <v-btn @click="$refs.LogoInput.click()">Choose Files</v-btn>
                        <input
                            style="display:none;"
                            type="file"
                            ref="LogoInput"
                            accept="image/*"
                        >
                        </v-flex>
                    </v-layout>
                    <span>img123.jpg</span> -->
          <!-- </v-flex>
                <v-flex xs12 md6> -->
          <v-data-table
            :headers="headers"
            :items="addons"
            :pagination.sync="pagination"
            class="elevation-1 mt-3"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-center">
                <v-text-field
                  label="Price"
                  hide-details
                  style="padding-bottom:10px;"
                ></v-text-field>
              </td>
              <td class="justify-center layout px-0">
                <v-switch
                  v-model="switch1"
                  color="primary"
                  style="max-width:50px;margin-top:17px;"
                ></v-switch>
              </td>
            </template>
          </v-data-table>
          <!-- </v-flex>
            </v-layout> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          flat
          @click="$emit('setDialog', false) && $emit('setEditIndex', -1)"
          >Cancel</v-btn
        >
        <v-btn color="green" flat>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  props: ["dialog", "editedIndex"],
  components: {
    VueTimepicker,
  },
  data() {
    return {
      start_time: "2",
      end_time: "3",
      headers: [
        {
          text: "Vehicle name",
          value: "name",
          align: "center",
          sortable: false,
        },
        { text: "Price", value: "price", align: "center", sortable: false },
        { text: "Action", value: "action", align: "center", sortable: false },
      ],
      addons: [
        {
          name: "รถบรรทุก",
          price: "Active",
          action: "",
        },
        {
          name: "รถมอเตอร์ไซค์",
          price: "Inactive",
          action: "",
        },
      ],
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New extra time" : "Edit extra time";
    },
  },
};
</script>
<style scoped>
.time-picker input.display-time {
  border: none;
}
.underline {
  border-bottom: 1px solid #949494;
}
</style>
